import React from 'react';
import { useSelector } from 'react-redux';

import { dynamic } from 'helpers/makeLazy';
import { useModal } from 'hooks/useModal';
import { emergentModal } from 'store/features';
import { ModalId } from 'types';

import { Modal } from 'components/@ux/modal';

const componentRecord: Record<
  ModalId,
  ((props?: Record<string, unknown>) => JSX.Element) | undefined
> = {
  DynamicModalForm: dynamic(() => import('modal/dynamic-modal-form')),
  ChangePassword: dynamic(() => import('modal/change-password')),
  ShowAllNotifications: dynamic(() => import('modal/show-all-notifications')),
  ShowOneNotification: dynamic(() => import('modal/show-one-notification')),
  StateHistory: dynamic(() => import('modal/state-history')),
  RowActionsDetails: dynamic(() => import('modal/row-action-details')),
  Confirm: dynamic(() => import('modal/confirm')),
  Confirmation: dynamic(() => import('modal/confirmation')),
  Token: dynamic(() => import('modal/token')),
  RaitingReviewTrip: dynamic(() => import('modal/raiting-review')),
  RfcsMetaDetails: dynamic(() => import('modal/rfcs-meta-details')),
  TripDetail: dynamic(() => import('modal/trip-detail')),
  TripCreateLegacy: dynamic(() => import('modal/trip-create-legacy')),
  DocumentError: dynamic(() => import('modal/document-error')),
  InterestedOtherPrice: dynamic(() => import('modal/interested-other-price')),
  TripStateHistory: dynamic(() => import('modal/trip-state-history')),
  AssignCarrier: dynamic(() => import('modal/assign-carrier')),
  AssignedCarrier: dynamic(() => import('modal/assigned-carrier')),
  CatalogNewUnit: dynamic(() => import('modal/catalogs/new-unit')),
  AreaCreate: dynamic(() => import('modal/area-create')),
  AreaUpdate: dynamic(() => import('modal/area-update')),
  ProfileCreate: dynamic(() => import('modal/profile-create')),
  ProfileUpdate: dynamic(() => import('modal/profile-update')),
  UserCreate: dynamic(() => import('modal/user-create')),
  UserUpdate: dynamic(() => import('modal/user-update')),
  Delete: dynamic(() => import('modal/delete')),
  CatalogNewTrailer: dynamic(() => import('modal/catalogs/new-trailer')),
  CatalogNewOperator: dynamic(() => import('modal/catalogs/new-operator')),
  CatalogNewCarrier: dynamic(() => import('modal/catalogs/new-carrier')),
  CatalogNewClient: dynamic(() => import('modal/catalogs/new-client')),
  CatalogNewLocation: dynamic(() => import('modal/catalogs/new-location')),
  CatalogNewMerchandise: dynamic(() => import('modal/catalogs/new-merchandise')),
  CarrierCreate: dynamic(() => import('modal/carrier-create')),
};

export const ModalContainer = (): JSX.Element | null => {
  const { modalId, modalProps = {} } = useModal();
  const configs = useSelector(emergentModal.selectors.getState) as Array<{
    id: ModalId;
    props?: Record<string, unknown>;
  }>; // TODO fix slice

  const Component = modalId ? componentRecord[modalId] : undefined;

  return (
    <>
      {!!Component && (
        <Modal key={modalId} disableEnforceFocus>
          <Component {...modalProps} />
        </Modal>
      )}
      {configs?.map(({ id, props }, index) => {
        const Component = componentRecord[id];
        return (
          !!Component && (
            <Modal key={index} disableEnforceFocus>
              <Component {...props} />
            </Modal>
          )
        );
      })}
    </>
  );
};
